import React, {Component} from 'react';
import {Helmet} from 'react-helmet';

// Assets
import DownArrow from '../assets/symbols/downarrow.svg';

// Components
import BtnContainer from '../components/BtnContainer';
import Calendly from '../components/Calendly';
import CtaBtn from '../components/CtaBtn';
import Footer from '../components/Footer';
import Modal from '../components/Modal';
import Navbar from '../components/Navbar';
import ServiceCards from '../components/ServiceCards';

class Speaker extends Component {
    state = {
        showModal: "none",
        displayMobile: "none"
      }

    componentDidMount(){
        window.addEventListener('load', this.loadHero);
        window.addEventListener('scroll', this.showServiceCards);
    }

    componentWillUnmount(){
        window.removeEventListener('load', this.loadHero);
        window.addEventListener('scroll', this.showServiceCards);
    }
    
    loadHero() {
        const speakerContent = document.getElementsByClassName("speakerContent");
        for (let i=0; i < speakerContent.length; i++) {
            setTimeout(function(){
                if (typeof(speakerContent[i])=== 'undefined'){
                    return null;
                }
                else {
                    speakerContent[i].classList.add("visible");
                    speakerContent[i].classList.remove("invisible");
                }
            }, i*1000)
        }
    }

    showServiceCards() {
        const ServiceCards = document.getElementsByClassName('ServiceCard');
        const condition = ServiceCards.length -1;
        if (window.scrollY > 500){
            for (let i=0; i < ServiceCards.length; i++){
                setTimeout(function(){
                    if(typeof(ServiceCards[i])==="undefined"){
                        return null;
                    }
                    else {
                        ServiceCards[i].classList.add("visible");
                        ServiceCards[i].classList.remove("invisible");
                    }
                },
                i*600)
            }
    }}

    scrollDown = () => {
        document.getElementById("speakerBenefits").scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth"});
    }

    toggleModal = () => {
    if (this.state.showModal == "none") {
        this.setState({
            showModal: "block"
        })
        window.scrollTo(0,0);
    }
    else {
        this.setState({
            showModal: "none"
        })
    }
    }

    toggleMobileMenu = () => {
    if (this.state.displayMobile == "none") {
        this.setState({
            displayMobile: "flex"
        })
    }
    else {
        this.setState({
            displayMobile: "none"
        })
    }}


    render() {
        return(
        <div className="Speaker noPadding">
        <Helmet>
            <title>Custom Web and Tech Solutions for Keynote Speakers | Candid Goat</title>
            <meta name="description" content="Your keynotes deliver, but what about your digital presence and processes? Candid Goat crafts custom websites and business flows tailored to the events industry." />
        </Helmet>
        <Navbar click={this.toggleModal} displayMobile={this.state.displayMobile} mobileMenu={this.toggleMobileMenu} />
        <Modal showModal={this.state.showModal} click={this.toggleModal}/>
        <div className="width-12 speakerHero">
            <div className="heroContent container flexColumn alignStart">
                <h2 className="titleFont boldest speakerContent invisible">You're Charismatic.</h2>
                <h2 className="titleFont boldest speakerContent invisible">You deliver.</h2>
                <h2 className="titleFont boldest speakerContent invisible">Your business should too.</h2>
                <p className="subTitleFont speakerContent invisible">Let us worry about your tech tasks,</p>
                <p className="subTitleFont speakerContent invisible">so you don’t have to.</p>
                <button onClick={()=>{this.scrollDown()}}><img src={DownArrow} alt="Down Arrow"/></button>
            </div>
        </div>
        <div className="leftText turnBlack width-12" id="speakerBenefits">
            <div className="centerText noPadding">
                <h3 className="subTitleFont bold turnBlack">We provide:</h3>
            </div>
            <div className="container">
                <ServiceCards cardList={["A website optimized for buyers and Google", "Clear and organized business flow", "The time and freedom to share your expertise and passion"]} />
            </div>
        </div>
        <Calendly />
        <Footer />
        </div>
        )
    }
}


export default Speaker;


// WEBPACK FOOTER //
// ./src/pages/Speaker.js